module.exports = __webpack_public_path__ + "img/16_106.e666ba2b.png";